
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tide-charts/[spotSlug]/[spotId]",
      function () {
        return require("private-next-pages/tide-charts/[spotSlug]/[spotId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tide-charts/[spotSlug]/[spotId]"])
      });
    }
  